export const signDocumentsSliceName = 'signDocuments'
